import EnhancedAdShow from './EnhancedAdShow/EnhancedAdShow';

const EnhancedAdShowDirective = (
  reactDirective,
  $state,
  CreativeService,
  FlashService,
  AdMarkupService
) => {
  return reactDirective(
    EnhancedAdShow,
    undefined,
    {
      restrict: 'E'
    },
    {
      $state,
      CreativeService,
      FlashService,
      AdMarkupService
    }
  );
};

EnhancedAdShowDirective.$inject = [
  'reactDirective',
  '$state',
  'CreativeService',
  'FlashService',
  'AdMarkupService'
];

export default EnhancedAdShowDirective;
